import { createMaskedInput } from './MaskedInput';
import { ZIP_CODE_MASK, ZIP_CODE_REGEX } from '../../constants/form';

export const MaskedZipCodeInput = createMaskedInput({
  mask: ZIP_CODE_MASK,
  unmask: true,
});

export const validateZipCode = (value: string) =>
  ZIP_CODE_REGEX.test(value) || 'ZIP Code must be in the format XXXXX or XXXXX-XXXX';
